var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnnaProfilePic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 500,
    height: 500
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 250,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 250,
    fill: "#FFF0B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-54.0098 357.818L-12.8686 353.892C-9.57002 353.577 -6.44989 355.45 -5.17661 358.511L25.8843 433.241C27.8334 437.932 24.6859 443.167 19.6273 443.651L-23.181 447.738C-26.5379 448.057 -29.6997 446.117 -30.9302 442.982L-60.3239 368.09C-62.1552 363.422 -59.0065 358.298 -54.0098 357.818Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-12.9345 491.242C-13.658 491.865 -48.2424 456.528 -66.7097 436.95L-48.2115 425.694L52.7916 489.072L-12.9345 491.242Z",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.559 74.9021C268.213 71.812 276.448 38.7336 327.807 45.8629C327.807 45.8629 302.187 44.4879 295.928 54.7632C295.928 54.7632 315.396 44.1073 328.545 50.9131C341.706 57.7176 345.633 83.5157 344.324 91.5478C343.003 99.5786 330.77 124.079 321.56 124.739C318.061 124.99 314.253 124.097 310.85 122.892C312.564 126.968 314.17 131.416 315.586 136.319C328.676 181.656 300.557 218.847 284.099 211.335C273.544 206.516 267.13 224.837 267.13 224.837L174.815 119.198C174.815 119.198 228.492 44.4392 267.559 74.9021Z",
    fill: "#A7163E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.084 358.185C185.129 366.536 200.23 373.422 219.187 377.795C290.24 394.204 317.467 334.178 327.701 292.975C318.003 287.432 308.887 286.211 303.628 285.583C298.487 284.977 293.084 284.575 288.61 284.354C280.637 278.245 268.749 253.245 266.119 214.432L262.776 215.327L206.775 230.647C206.775 230.647 209.334 248.439 210.595 265.257C211.571 278.415 211.725 290.992 209.227 294.069C204.859 295.016 202.229 295.636 202.229 295.636C202.229 295.636 202.229 295.655 202.206 295.688C201.456 296.92 185.201 323.625 173.084 358.185Z",
    fill: "#D7AE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.776 230.654C206.776 230.654 209.346 248.432 210.596 265.264C242.321 262.088 257.041 231.898 262.776 215.337L206.776 230.654Z",
    fill: "#BF9976"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.301 247.361C197.301 247.361 272.603 243.208 269.295 196.375C265.986 149.542 273.471 117.464 225.253 118.136C177.031 118.807 168.963 137.336 166.263 153.236C163.564 169.139 177.621 247.236 197.301 247.361Z",
    fill: "#D7AE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.634 127.043C177.249 112.123 186.26 114.583 191.484 118.465C230.98 92.9273 259.86 124.429 259.86 124.429C267.31 157.669 292.93 175.179 292.93 175.179C292.93 175.179 279.828 184.625 247.639 178.769C237.81 176.979 228.695 170.739 220.77 162.947C235.097 183.46 253.613 197.649 253.613 197.649C214.617 182.915 195.685 131.521 193.781 126.078C189.485 130.53 181.072 140.132 178.945 149.105C176.053 161.299 176.126 185.969 168.909 185.646C168.909 185.646 150.713 149.417 166.634 127.043Z",
    fill: "#A7163E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.105 291.87C185.105 291.87 307.792 262.1 361.127 306.074L319.104 491.871L334.472 677.678L94.5466 619.745C94.5466 619.745 101.297 596.23 147.304 533.702C193.316 471.175 173.3 379.46 185.105 291.87Z",
    fill: "#D7AE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.666 412.063C371.752 456.767 348.06 511.473 339.599 540.921C339.599 540.921 353.736 643.154 340.23 671.222C338.706 674.425 336.802 676.664 334.47 677.672C284.443 699.454 89.6173 678.302 81.3934 615.486C78.4041 592.662 155.603 512.374 160.101 502.634C161.97 498.605 163.957 485.543 154.908 458.472C142.078 498.006 118.384 543.657 94.5486 551.442C68.3571 560.009 -35.2092 482.871 -35.2092 482.871C-35.2092 482.871 -35.8066 473.501 -22.7144 464.639C-14.2953 458.939 5.04187 457.018 5.04187 457.018L71.2678 486.639C79.5786 472.426 100.285 374.091 123.403 329.703C140.785 296.334 187.198 291.5 187.198 291.5C187.198 291.5 206.511 322.122 253.23 317.779C299.937 313.436 308.481 284.855 308.481 284.855C308.481 284.855 349.916 290.36 362.673 300.654C364.886 302.439 385.437 353.493 377.666 412.063Z",
    fill: "#FF9D5A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.601 540.921C339.601 540.921 353.738 643.154 340.232 671.222C303.783 652.937 256.279 613.466 270.737 551.79C291.74 462.185 377.669 412.063 377.669 412.063C371.754 456.768 348.062 511.473 339.601 540.921Z",
    fill: "#FF7D23"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.481 284.855C308.481 284.855 368.66 291.99 385.224 317.779C406.168 350.387 454.845 430.689 453.251 463.415C453.251 463.415 451.218 479.675 333.332 581.301C333.332 581.301 301.162 573.975 327.235 558.944C327.235 558.944 398.897 456.889 406.227 450.433L356.82 397.957L308.481 284.855Z",
    fill: "#FF7D23"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-62.9712 358.631L-21.8288 354.702C-18.5302 354.388 -15.4089 356.261 -14.138 359.322L16.9241 434.053C18.8732 438.742 15.7269 443.98 10.6683 444.461L-32.1412 448.549C-35.4981 448.869 -38.6599 446.928 -39.8915 443.791L-69.2829 368.902C-71.1154 364.232 -67.9655 359.106 -62.9712 358.631Z",
    fill: "#2B478B"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnaProfilePic);
export default __webpack_public_path__ + "static/media/anna-profile-pic.5bf4e30bb4d7651acbe094023426ff7b.svg";
export { ForwardRef as ReactComponent };